import React, { useEffect } from "react";
import { Area, Component, DynamicMap, Polygon, TriggerSet, Vector } from "../services/map";
import { MonthYearSelector } from "../views/widgets/date_selector";
import { Dropdown } from "../views/widgets/input";
import { LoadingAnimation } from "../views/widgets/loading";


export function TestView() {
    return <div></div>;
}

// export function TestView() {
//     const map = new DynamicMap();
//     const canvasRef = React.createRef();
//     const containerRef = React.createRef();
//     const triggersRef = React.createRef();
//     const elementRef = React.createRef();
    
//     useEffect(() => {
//         map.canvas = canvasRef.current;
//         map.componentsContainer = containerRef.current;
//         map.triggersContainer = triggersRef.current;

//         const area = new Area({
//             coordinates: ProvinceCoordinates.provinces["2"].coords,
//             element: elementRef.current,
//             trigger: new TriggerSet({
//                 onClick: () => {
//                     console.log("Clicked");
//                 }
//             })
//         });

//         map.transform.offset = area.center;
//         map.components.push(area);

//         map.render();
//     });


//     const zoomMultiplier = 1.3;
//     const zoomIn = () => {
//         map.transform.zoomFactor *= zoomMultiplier;
//         map.render();
//     };

//     const zoomOut = () => {
//         map.transform.zoomFactor /= zoomMultiplier;
//         map.render();
//     };


//     const canvasHeight = 500;
//     const canvasWidth = 800;


//     return <div style={{ width: "fit-content", height: "fit-content", position: "relative" }}>
//         <div ref={containerRef} style={{ overflow: "hidden", whiteSpace: "nowrap", position: "absolute", height: canvasHeight, width: canvasWidth }}>
//             <svg ref={triggersRef} height={canvasHeight} width={canvasWidth} style={{ position: "absolute", top: 0, left: 0 }} />
//             <div ref={elementRef}>SOME TEXT</div>
//         </div>
//         <canvas ref={canvasRef} height={canvasHeight} width={canvasWidth} style={{ border: "1px solid #aaa" }}/>
//         <br />
//         <button onClick={zoomOut}>ZOOM OUT</button>
//         <button onClick={zoomIn}>ZOOM IN</button>
//     </div>
// }